import AdsError from './AdsError.js'

export class GetSubscriptionCommitmentOptionsAdsError extends AdsError {}
